<template>

  <v-app>


    <v-app-bar
        v-if="$route.meta.fieldJudge"
        app
        color="primary"
        dark
        elevation="1"
        height="56"
    >
      <v-toolbar-title class="font-weight-bold">Kampfrichter</v-toolbar-title>
      <v-spacer />
      <v-btn icon @click="handleLogout">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-bottom-navigation
        app
        grow
        v-else-if="$route.meta.mobile"
        color="primary"
        background-color="white"
        elevation="8"
        height="70"
        class="bottom-nav-enhanced"
    >

      <v-btn
          :value="'live'"
          @click="$router.push('/live')"
          class="nav-btn"
          :class="{ 'active-btn': $route.path === '/live' }"
      >
        <span class="nav-text">Live</span>
        <v-icon size="24" class="nav-icon"> mdi-broadcast </v-icon>
      </v-btn>

      <v-btn
          :value="'liveStart'"
          @click="$router.push('/liveStart')"
          class="nav-btn"
          :class="{ 'active-btn': $route.path === '/liveStart' }"
      >
        <span class="nav-text">Startlisten</span>
        <v-icon size="24" class="nav-icon">mdi-format-list-bulleted</v-icon>
      </v-btn>

      <v-btn
          :value="'liveResults'"
          @click="$router.push('/liveResults')"
          class="nav-btn"
          :class="{ 'active-btn': $route.path === '/liveResults' }"
      >
        <span class="nav-text">Ergebnisse</span>
        <v-icon size="24" class="nav-icon">mdi-podium</v-icon>
      </v-btn>

      <v-btn
          :value="'register'"
          @click="$router.push('/register')"
          class="nav-btn"
          :class="{ 'active-btn': $route.path === '/register' }"
      >
        <span class="nav-text">Registrieren</span>
        <v-icon size="24" class="nav-icon">mdi-account-plus</v-icon>
      </v-btn>

    </v-bottom-navigation>

    <v-navigation-drawer
        app
        :mini-variant.sync="mini"
        permanent
        v-else-if="$route.name !== 'Login' && !$route.meta.fieldJudge"

    >

      <template v-slot:append>
        <v-list-item class="px-2">

          <v-btn
              icon
              @click.stop="mini = !mini"
          >
            <v-icon v-if="!mini">mdi-chevron-left</v-icon>
            <v-icon v-if="mini">mdi-chevron-right</v-icon>

          </v-btn>

        </v-list-item>

      </template>

      <v-list
          dense
          nav
      >
        <v-list-item
            v-for="item in filteredItems"
            :key="item.title"
            link
            @click.stop="$router.push({ path: item.route})"
        >

          <v-tooltip bottom v-if="mini">
            <template v-slot:activator="{ on, attrs }">
              <v-list-item-icon v-bind="attrs" v-on="on">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
            </template>
            <span>{{ item.title }}</span>
          </v-tooltip>

          <v-list-item-icon v-if="!mini">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-divider></v-divider>


        <v-list-item
            link
            @click.stop="handleLogout"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>

    </v-navigation-drawer>



    <!-- Sizes your content based upon application components -->
    <v-main>

      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <router-view></router-view>
      </v-container>

    </v-main>

    <snackbar ref="snackbar"></snackbar>

    <v-footer
        app
        v-if="!$route.meta.mobile && $route.name !== 'Login' && !$route.meta.fieldJudge"
        color="grey lighten-4"
        elevation="2"
        class="footer-desktop"
    >
      <v-icon small class="mr-1 grey--text text--darken-1">mdi-trophy-outline</v-icon>
      <span class="footer-event-title grey--text text--darken-2">{{ eventTitle || '—' }}</span>

      <v-divider vertical class="mx-3"></v-divider>

      <template v-if="currentRound">
        <v-icon small class="mr-1 grey--text text--darken-1">mdi-rotate-360</v-icon>
        <span class="footer-round-info grey--text text--darken-2">
          Runde {{ currentRound.roundNumber }} · {{ currentRound.gender === 'HERREN' ? 'Herren' : 'Damen' }}
        </span>
        <template v-if="currentCompetitorRound && currentCompetitorRound.competitor">
          <v-icon x-small class="mx-2 grey--text">mdi-chevron-right</v-icon>
          <v-icon small class="mr-1 grey--text text--darken-1">mdi-account</v-icon>
          <span class="footer-round-info grey--text text--darken-2">
            {{ currentCompetitorRound.competitor.firstName }} {{ currentCompetitorRound.competitor.lastName }}
          </span>
          <span class="footer-round-pos grey--text ml-1">
            ({{ (currentRound.completedCompetitors || 0) + 1 }} / {{ currentRound.numberOfCompetitors }})
          </span>
        </template>
      </template>
      <template v-else>
        <v-icon small class="mr-1 grey--text">mdi-rotate-360</v-icon>
        <span class="footer-round-info grey--text">Keine Runde aktiv</span>
      </template>

      <v-spacer></v-spacer>
      <v-chip
          x-small
          :color="liveStatus ? 'green darken-1' : 'grey lighten-1'"
          :text-color="liveStatus ? 'white' : 'grey darken-1'"
          class="mr-2 footer-chip"
      >
        <v-icon x-small left>{{ liveStatus ? 'mdi-broadcast' : 'mdi-broadcast-off' }}</v-icon>
        {{ liveStatus ? 'Live' : 'Offline' }}
      </v-chip>
      <v-chip
          x-small
          :color="registrationStatus ? 'green darken-1' : 'grey lighten-1'"
          :text-color="registrationStatus ? 'white' : 'grey darken-1'"
          class="footer-chip mr-2"
      >
        <v-icon x-small left>{{ registrationStatus ? 'mdi-account-check' : 'mdi-account-off' }}</v-icon>
        {{ registrationStatus ? 'Registrierung offen' : 'Registrierung geschlossen' }}
      </v-chip>
      <v-chip
          x-small
          :color="fieldJudgeStatus ? 'green darken-1' : 'grey lighten-1'"
          :text-color="fieldJudgeStatus ? 'white' : 'grey darken-1'"
          class="footer-chip"
      >
        <v-icon x-small left>mdi-gavel</v-icon>
        {{ fieldJudgeStatus ? 'Kampfrichter aktiv' : 'Kampfrichter inaktiv' }}
      </v-chip>
      <v-divider vertical class="mx-3"></v-divider>
      <span class="version-label grey--text">v{{ appVersion }}</span>
    </v-footer>

  </v-app>

</template>

<script>

import {EventBus} from "@/plugins/event-bus";
import snackbar from "@/components/SnackBar.vue";
import TimerApi from "@/plugins/timer-api";

export default {
  name: 'App',
  components: {snackbar},

  data() {
    return {
      appVersion: (process.env.VUE_APP_VERSION || 'dev').substring(0, 7),
      eventTitle: null,
      liveStatus: false,
      registrationStatus: false,
      fieldJudgeStatus: false,
      currentRound: null,
      currentCompetitorRound: null,
      items: [

        {title: 'Teilnehmer', icon: 'mdi-account-multiple-outline', route: '/competitor-rounds', roles: ['JUDGE', 'ADMIN']},
        {title: 'Runden', icon: 'mdi-rotate-360', route: '/rounds', roles: ['JUDGE', 'ADMIN']},
        {title: 'Veranstaltung', icon: 'mdi-scoreboard-outline', route: '/competition', roles: ['JUDGE', 'ADMIN']},

        {title: 'Kampfrichter', icon: 'mdi-gavel', route: '/field-judge', roles: ['JUDGE', 'ADMIN', 'FIELD_JUDGE']},

        {title: 'Statistiken', icon: 'mdi-chart-bar', route: '/statistics', roles: ['JUDGE', 'ADMIN']},


        {title: 'Admin', icon: 'mdi-cog-outline', route: '/admin', roles: ['JUDGE', 'ADMIN']},

      ],
      currentUser: null,
      right: null,
      mini: true,

    }

  },

  computed: {
    filteredItems() {
      const role = this.currentUser?.role
      return this.items.filter(item => !item.roles || item.roles.includes(role))
    }
  },

  // If reload, setACtiveButton is not called, so we call it here
  watch: {
    '$route': function() {
      this.currentUser = TimerApi.getCurrentUser()
      this.setActiveButton();
    }
  },

  mounted() {
    this.$root.snackbar = this.$refs.snackbar;
    this.currentUser = TimerApi.getCurrentUser();
    this.setActiveButton();
    this.fetchFooterData();
    this.fetchRoundData();
    this._roundPoll = setInterval(this.fetchRoundData, 10000);
  },

  beforeDestroy() {
    clearInterval(this._roundPoll);
  },

  created() {
    EventBus.$on('show-error-snackbar', (message) => {
      this.$root.snackbar.showError({message: message})
    });
    EventBus.$on('live-status-updated', (status) => {
      this.liveStatus = status;
    });
    EventBus.$on('registration-status-updated', (status) => {
      this.registrationStatus = status;
    });
    EventBus.$on('field-judge-status-updated', (status) => {
      this.fieldJudgeStatus = status;
    });
  },

  methods: {
    async fetchRoundData() {
      try {
        const [roundRes, crRes] = await Promise.all([
          TimerApi.getCurrentRound(),
          TimerApi.getCurrentCompetitorRound(),
        ]);
        this.currentRound = roundRes.data || null;
        this.currentCompetitorRound = crRes.data || null;
      } catch {
        this.currentRound = null;
        this.currentCompetitorRound = null;
      }
    },
    async fetchFooterData() {
      try {
        const [titleRes, liveRes, regRes, fjRes] = await Promise.all([
          TimerApi.getEventTitle(),
          TimerApi.getLiveStatus(),
          TimerApi.getRegistrationStatus(),
          TimerApi.getFieldJudgeStatus(),
        ]);
        this.eventTitle = titleRes.data;
        this.liveStatus = liveRes.data;
        this.registrationStatus = regRes.data;
        this.fieldJudgeStatus = fjRes.data;
      } catch {
        // footer data unavailable (e.g. not logged in yet)
      }
    },
    handleLogout() {
      TimerApi.logout();
      this.$router.push('/login');

    },
    setActiveButton() {
      this.$nextTick(() => {
        const buttons = document.querySelectorAll('.nav-btn');
        const routePath = this.$route.path.replace(/^\//, '');
        buttons.forEach((button) => {
        const value = button.getAttribute('value');
        if (routePath === value) {
          button.classList.add('v-btn--active');
        } else {
          button.classList.remove('v-btn--active');
        }
      });
    });
    },
  },

};
</script>


<style scoped>
.bottom-nav-enhanced {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1) !important;
}

.nav-btn {
  flex-direction: column !important;
  height: 100% !important;
  min-width: 80px !important;
  padding: 8px 12px !important;
  border-radius: 0 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  position: relative;
}

.nav-btn:hover {
  background-color: var(--v-secondary-base) !important;
}

.nav-btn.active-btn {
  background-color: var(--v-primary-base) !important;
  color: white !important;
}

.nav-btn.active-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background-color: white !important;
  border-radius: 0 0 3px 3px;
}

.nav-text {
  font-size: 12px !important;
  font-weight: 500 !important;
  margin-bottom: 4px !important;
  line-height: 1.2 !important;
  text-transform: capitalize !important;
  letter-spacing: 0.5px !important;
}

.nav-icon {
  opacity: 0.8;
  transition: all 0.3s ease !important;
}

.nav-btn:hover .nav-icon,
.nav-btn.active-btn .nav-icon {
  opacity: 1;
  transform: scale(1.1);
}

.nav-btn.active-btn .nav-text {
  font-weight: 600 !important;
}

/* Ripple effect enhancement */
.nav-btn .v-ripple__container {
  border-radius: 8px !important;
}

.footer-desktop {
  height: 36px !important;
  min-height: 36px !important;
  padding: 0 16px !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1) !important;
}

.footer-event-title {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.3px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 300px;
}

.footer-round-info {
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}

.footer-round-pos {
  font-size: 11px;
  white-space: nowrap;
}

.footer-chip {
  font-size: 10px !important;
  height: 20px !important;
}

.version-label {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.38);
  font-family: monospace;
}


/* Mobile responsiveness */
@media (max-width: 360px) {
  .nav-text {
    font-size: 10px !important;
  }

  .nav-icon {
    font-size: 20px !important;
  }

  .nav-btn {
    min-width: 60px !important;
    padding: 6px 8px !important;
  }
}
</style>